// @ts-ignore
const imageUrl = import.meta.env.VITE_API_IMAGE_URL || '';

const FskattBastianGroup2023 = `${imageUrl}/F-skattInvozioLvSia.pdf`;
const FörsäkringsbrevTryggHansa = `https://invozioprod.blob.core.windows.net/invoice-files/Försäkringsbrev_Invozio.pdf`;
const bankIntygDanskeBank = `https://invozioprod.blob.core.windows.net/files/revolut-bank-certificate.pdf?sp=r&st=2025-05-14T10:03:02Z&se=2050-05-14T18:03:02Z&spr=https&sv=2024-11-04&sr=b&sig=UQA7RyvkNJV17ee9O2oupRpcFuoTmpdNyATQGHZUq8g%3D`;
const DownloadIcon = '/assets/svg/download-icon.svg';

export const companyLinks = [

    { label: "INVOZIO_LV_SIA", en: 'about-invozio', sv: 'om-invozio' },
    { label: "ORG_NUMBER", en: 'about-invozio', sv: 'om-invozio' },
    { label: "DOWNLOAD_TAX_CERTIFICATE", icon: DownloadIcon, link: FskattBastianGroup2023 },
    { label: "DOWNLOAD_BANK_CERTIFICATE", icon: DownloadIcon, link: bankIntygDanskeBank },
    { label: "DOWNLOAD_INSURANCE_CERTIFICATE", icon: DownloadIcon, link: FörsäkringsbrevTryggHansa },
];

export const quickLinks = [
    { label: "ABOUT_US", en: 'about-invozio', sv: 'om-invozio' },
    { label: "CONTACT_US", en: 'contact-us', sv: 'kontakta-oss' },
    { label: "FUNCTIONS", en: 'function', sv: 'funktion' },
    { label: "SITE_MAP", url: '/sitemap.xml' },
];

export const infoLinks = [
    { label: "FAQ", en: 'faq', sv: 'faq' },
    // { label: "NEWS", en: 'news', sv: 'nyheter' },
    { label: "HOW_IT_WORKS", en: 'how-works-invozio', sv: 'hur-fungerar-invozio' },
];

export const legalLinks = [
    { label: "PRIVACY_POLICY", en: 'cookies', sv: 'cookies' },
];